var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "6.999 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.711 18.704c-.553-.97-1.85-1.717-3.462-1.977v-.45a2.49 2.49 0 0 0 1.25-2.152V13.5a2.5 2.5 0 1 0-5 0v.625c0 .923.506 1.72 1.25 2.153v.449c-1.61.26-2.908 1.008-3.46 1.977A5.96 5.96 0 0 1 8.998 15c0-3.308 2.692-6 6-6 3.31 0 6 2.692 6 6a5.97 5.97 0 0 1-1.288 3.704M14.991 21h.018-.019m.008-14A8 8 0 1 0 15 23a8 8 0 0 0 0-16"
})));
export default SvgProfileMenu;